import { Injectable } from "@angular/core";
import {
  ApiModule,
  AuthenticationService,
  LoginRequest,
  LoginResponse,
  RegistrationService,
} from "auth-api";
import {
  DefaultService as StdService,
  ConfigurationVariablesList,
  StandardService,
} from "std-api";
import {
  ProfileService,
  Profile,
  InlineResponse200,
  MiscService as ProfileMiscService,
  PaymentMethodService,
  PrepaidCreditsService,
} from "profile-api";
import {
  TenderService,
  WorkflowService,
  PublicService as TenderPublicService,
  TenderInvitationService,
} from "tender-api";
import {
  ParticipationService,
  WorkflowService as ParticipationWorkflowService,
} from "participation-api";
import { QuestionService } from "question-api";
import { DefaultService as SharingService } from "sharing-api";
import { DesignerService } from "designer-api";
import { ShowcaseService } from "showcase-api";
import { FeedbackService } from "feedback-api";
import { AnnouncementService } from "announcement-api";
import { AnnouncementOfferService } from "announcement-offer-api";
import { WorkflowService as AnnouncementWorkflowService} from "announcement-api";
import { WorkflowService as AnnouncementOfferWorkflowService} from "announcement-offer-api";
import { PublicService as PublicAnnouncementService} from "announcement-api";

const MAX_CACHE_MILLIS: number = 0;

@Injectable({
  providedIn: "root",
})
export class CommonService {
  constructor(
    public authenticationService: AuthenticationService,
    public stdService: StdService,
    public standardService: StandardService,
    public registrationService: RegistrationService,
    public profileService: ProfileService,
    public profileMiscService: ProfileMiscService,
    public paymentMethodService: PaymentMethodService,
    public tenderService: TenderService,
    public workflowService: WorkflowService,
    public participationService: ParticipationService,
    public tenderPublicService: TenderPublicService,
    public participationWorkflowService: ParticipationWorkflowService,
    public prepaidCreditsService: PrepaidCreditsService,
    public questionService: QuestionService,
    public sharingService: SharingService,
    public designerService: DesignerService,
    public showcaseService: ShowcaseService,
    public feedbackService: FeedbackService,
    public tenderInvitationService: TenderInvitationService,
    public announcementService: AnnouncementService,
    public announcementWorkflowService: AnnouncementWorkflowService,
    public publicAnnouncementService: PublicAnnouncementService,
    public announcementOfferService: AnnouncementOfferService,
    public announcementOfferWorkflowService: AnnouncementOfferWorkflowService
  ) {}

  public getToken() {
    return localStorage.getItem("TOKEN");
  }

  public setToken(value: string) {
    localStorage.setItem("TOKEN", value);
  }

  public deleteToken() {
    localStorage.removeItem("TOKEN");
  }

  public getStandardService(): StandardService {
    this.standardService.configuration.accessToken = this.getToken();
    return this.standardService;
  }

  public getStdService(): StdService {
    this.stdService.configuration.accessToken = this.getToken();
    return this, this.stdService;
  }

  public getAuthenticationService(): AuthenticationService {
    this.authenticationService.configuration.accessToken = this.getToken();
    return this.authenticationService;
  }

  public getRegistrationService(): RegistrationService {
    this.registrationService.configuration.accessToken = this.getToken();
    return this.registrationService;
  }

  public getProfileService(): ProfileService {
    this.profileService.configuration.accessToken = this.getToken();
    return this.profileService;
  }

  public getProfileMiscService(): ProfileMiscService {
    this.profileMiscService.configuration.accessToken = this.getToken();
    return this.profileMiscService;
  }

  public getPaymentMethodService(): PaymentMethodService {
    this.paymentMethodService.configuration.accessToken = this.getToken();
    return this.paymentMethodService;
  }

  public getTenderService(): TenderService {
    this.tenderService.configuration.accessToken = this.getToken();
    return this.tenderService;
  }

  public getWorkflowService(): WorkflowService {
    this.workflowService.configuration.accessToken = this.getToken();
    return this.workflowService;
  }

  public getParticipationService(): ParticipationService {
    this.participationService.configuration.accessToken = this.getToken();
    return this.participationService;
  }

  public getTenderPublicService(): TenderPublicService {
    this.tenderPublicService.configuration.accessToken = this.getToken();
    return this.tenderPublicService;
  }

  public getParticipationWorkflowService(): ParticipationWorkflowService {
    this.participationWorkflowService.configuration.accessToken =
      this.getToken();
    return this.participationWorkflowService;
  }

  public getPrepaidCreditsService(): PrepaidCreditsService {
    this.prepaidCreditsService.configuration.accessToken = this.getToken();
    return this.prepaidCreditsService;
  }

  public getQuestionService(): QuestionService {
    this.questionService.configuration.accessToken = this.getToken();
    return this.questionService;
  }

  public getSharingService(): SharingService {
    this.sharingService.configuration.accessToken = this.getToken();
    return this.sharingService;
  }

  public getDesignerService(): DesignerService {
    this.designerService.configuration.accessToken = this.getToken();
    return this.designerService;
  }

  public getShowcaseService(): ShowcaseService {
    this.showcaseService.configuration.accessToken = this.getToken();
    return this.showcaseService;
  }

  public getFeedbackService(): FeedbackService {
    this.feedbackService.configuration.accessToken = this.getToken();
    return this.feedbackService;
  }

  public getTenderInvitationService(): TenderInvitationService {
    this.tenderInvitationService.configuration.accessToken = this.getToken();
    return this.tenderInvitationService;
  }

	public getAnnouncementsService(): AnnouncementService {
    this.announcementService.configuration.accessToken = this.getToken();
    return this.announcementService;
  }

  public getAnnouncementOfferService(): AnnouncementOfferService {
    this.announcementOfferService.configuration.accessToken = this.getToken();
    return this.announcementOfferService;
  }

  public getAnnouncementWorflowService(): AnnouncementWorkflowService {
    this.announcementWorkflowService.configuration.accessToken = this.getToken();
    return this.announcementWorkflowService;
  }

  public getAnnouncementOfferWorkflowService(): AnnouncementOfferWorkflowService {
    this.announcementOfferWorkflowService.configuration.accessToken = this.getToken();
    return this.announcementOfferWorkflowService;
  }

  public getPublicAnnouncementsService(): PublicAnnouncementService {
    this.publicAnnouncementService.configuration.accessToken = this.getToken();
    return this.publicAnnouncementService;
  }

  public getProvinces() {
    let provincesDate: Date = new Date(localStorage.getItem("PROVINCES_DATE"));
    let provinces = JSON.parse(localStorage.getItem("PROVINCES"));
    if (
      provincesDate == null ||
      new Date().getTime() - provincesDate.getTime() > MAX_CACHE_MILLIS ||
      provinces == null
    ) {
      return new Promise((resolve, reject) => {
        this.getProfileMiscService()
          .provincesGet()
          .subscribe(
            (provinceList: InlineResponse200) => {
              console.log(provinceList);
              localStorage.setItem("PROVINCES", JSON.stringify(provinceList));
              localStorage.setItem("PROVINCES_DATE", new Date().toString());
              resolve(provinceList);
            },
            (error) => {
              console.log("Unable to get provinces!");
              console.log(error);
              reject(error);
            }
          );
      });
    } else {
      console.log("Using cache of provinces");
      return new Promise((resolve) => {
        resolve(provinces);
      });
    }
  }

  public getConfigurationVariables() {
    let configVarsDate: Date = new Date(localStorage.getItem("CONF_VARS_DATE"));
    let configVars = JSON.parse(localStorage.getItem("CONF_VARS"));
    if (
      configVarsDate == null ||
      new Date().getTime() - configVarsDate.getTime() > MAX_CACHE_MILLIS ||
      configVars == null
    ) {
      return new Promise((resolve, reject) => {
        this.getStdService()
          .stdConfigurationVariablesGet()
          .subscribe(
            (confVars: ConfigurationVariablesList) => {
              console.log(confVars);
              let confVarsObj = <any>{};
              confVars.variables.forEach((tuple) => {
                confVarsObj[tuple.name] = tuple.value;
              });
              localStorage.setItem("CONF_VARS", JSON.stringify(confVarsObj));
              localStorage.setItem("CONF_VARS_DATE", new Date().toString());
              resolve(confVarsObj);
            },
            (error) => {
              console.log("Unable to get configuration variables!");
              console.log(error);
              reject(error);
            }
          );
      });
    } else {
      console.log("Using cache of configuration variables");
      return new Promise((resolve) => {
        resolve(configVars);
      });
    }
  }

  public login(username: string, password: string) {
    let loginRequest: LoginRequest = {
      username: username,
      password: password,
      os: "browser",
      ver: "1.0",
      verApp: "1.0",
    };
    return new Promise((resolve, reject) => {
      this.getAuthenticationService()
        .authLoginPost(loginRequest)
        .subscribe(
          (loginResponse: LoginResponse) => {
            if (loginResponse.token) {
              this.setToken(loginResponse.token);
              this.getProfile().then((profile: Profile) => {
                this.getConfigurationVariables().then(
                  (confVars: ConfigurationVariablesList) => {
                    console.log(confVars);
                    resolve(profile);
                  }
                );
              });
            }
            console.log(loginResponse);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public getProfile() {
    if (this.getToken() === null) {
      localStorage.removeItem("PROFILE_DATE");
      localStorage.removeItem("PROFILE");
      return new Promise((resolve, reject) => {
        reject("No profile available for unauthenticated users");
      });
    }

    var profileDate: Date = new Date(localStorage.getItem("PROFILE_DATE"));
    var profile = JSON.parse(localStorage.getItem("PROFILE"));
    if (
      profileDate == null ||
      new Date().getTime() - profileDate.getTime() > MAX_CACHE_MILLIS ||
      profile == null
    ) {
      return new Promise((resolve, reject) => {
        this.getProfileService()
          .profileGet()
          .subscribe(
            (profile: Profile) => {
              console.log(profile);
              localStorage.setItem("PROFILE_DATE", new Date().toString());
              localStorage.setItem("PROFILE", JSON.stringify(profile));
              resolve(profile);
            },
            (error) => {
              console.log("Unable to get profile!");
              console.log(error);
              reject(error);
            }
          );
      });
    } else {
      console.log("Using cache of profile");
      return new Promise((resolve) => {
        resolve(profile);
      });
    }
  }

  public saveProfile(profile: Profile) {
    if (profile.logo && !profile.logo.base64Content) {
      profile.logo = null;
    }
    if (profile.visura && !profile.visura.base64Content) {
      profile.visura = null;
    }
    if (profile.durc && !profile.durc.base64Content) {
      profile.durc = null;
    }

    return new Promise((resolve, reject) => {
      this.getProfileService()
        .profilePost(profile)
        .subscribe(
          (res: Profile) => {
            console.log("PROFILE:" + JSON.stringify(res));
            localStorage.setItem("PROFILE_DATE", new Date().toString());
            localStorage.setItem("PROFILE", JSON.stringify(res));
            resolve(res);
          },
          (error) => {
            reject(error);
            console.log("Error during profile update: ");
            console.log(error);
          }
        );
    });
  }

  public logout() {
    this.deleteToken();
    localStorage.removeItem("PROFILE");
    localStorage.removeItem("PROFILE_DATE");
  }

  static EMAIL_REGEXP = new RegExp("[A-z0-9.+_-]+@[A-z0-9._-]+.[A-z]{2,6}");

  static FISCAL_CODE_REGEXP = new RegExp(
    "^[a-zA-Z]{6}[0-9]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9]{2}([a-zA-Z]{1}[0-9]{3})[a-zA-Z]{1}$"
  );
  vaidateFiscalCode(fiscalCode: string) {
    if (fiscalCode) {
      return CommonService.FISCAL_CODE_REGEXP.test(fiscalCode);
    }
    return true;
  }

  static PHONE_REGEXP = new RegExp("^([+]39)?(3)([\\d]{8,9})$");

  public getPhoneValidator() {
    return CommonService.PHONE_REGEXP;
  }
}
